/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { OwnerDraftsControllerOwnerQueryResponse, OwnerDraftsControllerOwnerPathParams, OwnerDraftsControllerOwner400, OwnerDraftsControllerOwner401, OwnerDraftsControllerOwner403, OwnerDraftsControllerOwner404 } from "../../models/ownerDraftsController/OwnerDraftsControllerOwner";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { ownerDraftsControllerOwner } from "../../clients/owner-draftsService/ownerDraftsControllerOwner";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const ownerDraftsControllerOwnerQueryKey = (id: OwnerDraftsControllerOwnerPathParams["id"]) => [{
  url: '/api/v1/document-drafts/owner/:id',
  params: {
    id: id
  }
}] as const;
export type OwnerDraftsControllerOwnerQueryKey = ReturnType<typeof ownerDraftsControllerOwnerQueryKey>;
export function ownerDraftsControllerOwnerQueryOptions(id: OwnerDraftsControllerOwnerPathParams["id"], config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = ownerDraftsControllerOwnerQueryKey(id);
  return queryOptions<OwnerDraftsControllerOwnerQueryResponse, ResponseErrorConfig<OwnerDraftsControllerOwner400 | OwnerDraftsControllerOwner401 | OwnerDraftsControllerOwner403 | OwnerDraftsControllerOwner404>, OwnerDraftsControllerOwnerQueryResponse, typeof queryKey>({
    enabled: !!id,
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return ownerDraftsControllerOwner(id, config);
    }
  });
}

/**
 * {@link /api/v1/document-drafts/owner/:id}
 */
export function useOwnerDraftsControllerOwner<TData = OwnerDraftsControllerOwnerQueryResponse, TQueryData = OwnerDraftsControllerOwnerQueryResponse, TQueryKey extends QueryKey = OwnerDraftsControllerOwnerQueryKey>(id: OwnerDraftsControllerOwnerPathParams["id"], options: {
  query?: Partial<QueryObserverOptions<OwnerDraftsControllerOwnerQueryResponse, ResponseErrorConfig<OwnerDraftsControllerOwner400 | OwnerDraftsControllerOwner401 | OwnerDraftsControllerOwner403 | OwnerDraftsControllerOwner404>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? ownerDraftsControllerOwnerQueryKey(id);
  const query = useQuery({
    ...ownerDraftsControllerOwnerQueryOptions(id, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<OwnerDraftsControllerOwner400 | OwnerDraftsControllerOwner401 | OwnerDraftsControllerOwner403 | OwnerDraftsControllerOwner404>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}